import { useParams } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "@js/hooks";

import { resetPassword } from "../actions";
import { AuthComponent } from "../components/auth-component";
import { ResetPasswordForm } from "../forms";

import { AuthResetPasswordLayout } from "./layout/sign-in-layout";

type FormValues = {
  new_password1: string;
};

export type ResetPasswordProps = {
  values: FormValues;
  uid: string;
  token: string;
};

const ResetPasswordPage = () => {
  const { uid, token } = useParams();
  const resetPasswordMessage = useAppSelector(
    (state) => state.auth.resetPasswordMessage,
  );

  const dispatch = useAppDispatch();

  const onSubmit = async (props: ResetPasswordProps): Promise<void> => {
    return dispatch(resetPassword(props)).then(() => {
      // reload the page to reset referrer policy headers
      window.location.replace("/auth/login/?message=password_reset");
    });
  };

  return (
    <AuthResetPasswordLayout pageTitle="New password">
      <AuthComponent
        title="Set your new password"
        titleSize="medium"
        messageCode={resetPasswordMessage ?? undefined}
      >
        {uid && token && (
          <ResetPasswordForm
            onSubmit={(values: FormValues) =>
              onSubmit({
                values,
                token,
                uid,
              })
            }
          />
        )}
      </AuthComponent>
    </AuthResetPasswordLayout>
  );
};

export default ResetPasswordPage;
